function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 58 57"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 0a2 2 0 012 2v51h51a2 2 0 110 4H0V2a2 2 0 012-2zm29 39.243L57.121 13.12 52.88 8.88 31 30.757l-11.5-11.5L5.879 32.88l4.242 4.242 9.379-9.378 11.5 11.5z",
  fill: "#D7D5D2"
}));